import { Button, Paper, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useContext } from 'react'
import { OvertimeClaimContext } from './OvertimeClaims'

const OlderClaims = ({ oldestClaim, setOldestClaim }) => {
  const { filter, setFilter } = useContext(OvertimeClaimContext)
  if (!oldestClaim) {
    return null
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        px: 2,
        py: 1,
        borderRadius: 2,
        bgcolor: 'background.paper',
        boxShadow: '0 10px 28px rgba(15,23,42,0.06)',
        border: 'solid 1px',
        borderColor: 'contrast.main',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="space-between"
        gap={1}
      >
        <Typography variant="body2">
          Pending overtime claims exist before this date range
        </Typography>
        <Button
          onClick={() => {
            setFilter((prev) => ({
              ...prev,
              startDate: moment(oldestClaim),
            }))
            setOldestClaim(null)
          }}
          color="contrast"
        >
          Show Older Claims
        </Button>
      </Stack>
    </Paper>
  )
}

export default OlderClaims
